import startOfWeek from "date-fns/startOfWeek";
import { useMemo } from "react";
import { useSelector } from "react-redux";

import { getDayNumber } from "../../../features/scheduler/grid-scheduler/utils";
import { StoreType } from "../../../utils/types";
import { FullTimeShiftRootState } from "../store/full-time-shifts-type";

const useFullTimeShiftsData = () => {
  const currentDate = useSelector(
    (state: any) => state.fullTimeShifts?.currentDate
  ) ?? new Date().toISOString();

  const weekStartDay = useSelector(
    (state: any) => state.user?.userData?.weekStartDay
  );

  const getFullTimeShiftsStatus = useSelector(
    (state: FullTimeShiftRootState) => state.fullTimeShifts?.getFullTimeShifts?.status
  );

  const getFullTimeShiftsErrorMessage = useSelector(
    (state: FullTimeShiftRootState) => state.fullTimeShifts?.getFullTimeShifts?.errorMessage
  );

  const fullTimeShifts = useSelector(
    (state: FullTimeShiftRootState) => state.fullTimeShifts?.fullTimeShifts
  );

  const filterData = useSelector(
    (state: FullTimeShiftRootState) => state.fullTimeShifts?.filterData
  );

  const getFullTimeShiftsFiltersStatus = useSelector(
    (state: FullTimeShiftRootState) => state.fullTimeShifts?.getFullTimeShiftsFilters?.status
  );

  const getFullTimeShiftsFiltersErrorMessage = useSelector(
    (state: FullTimeShiftRootState) => state.fullTimeShifts?.getFullTimeShiftsFilters?.errorMessage
  );

  const getFullTimeShiftsMetaStatus = useSelector(
    (state: FullTimeShiftRootState) => state.fullTimeShifts?.getFullTimeShiftsMeta?.status
  );

  const startingDay = useMemo(() => {
    return startOfWeek(new Date(new Date(currentDate).setHours(0, 0, 0, 0)), {
      weekStartsOn: getDayNumber(weekStartDay),
    });
  }, [currentDate, weekStartDay]);

  const selectedLocation = useSelector(
    (state: FullTimeShiftRootState) => state.fullTimeShifts?.selectedLocation
  );

  const shiftMetaList = useSelector(
    (state: FullTimeShiftRootState) => state.fullTimeShifts?.shiftMetaList
  );

  const jobs = useSelector(
    (state: FullTimeShiftRootState) => state.fullTimeShifts?.filterData?.jobs
  );

  const reassignWorkersStatus = useSelector(
    (state: FullTimeShiftRootState) => state.fullTimeShifts?.reassignWorkers?.status
  );

  const reassignWorkersErrorMessage = useSelector(
    (state: FullTimeShiftRootState) => state.fullTimeShifts?.reassignWorkers?.errorMessage
  );

  const isUpdateDemandOpen = useSelector(
    (state: StoreType) => state.shiftDemand?.isShiftDemandOpen
  );

  const postShiftDemandStatus = useSelector(
      (state: StoreType) => state.shiftDemand?.postFTShiftDemands?.status
    );

  const getLatestSchedulingStatusStatus = useSelector(
    (state: FullTimeShiftRootState) => state.fullTimeShifts?.getLatestSchedulingStatus?.status
  );

  const getLatestSchedulingStatusErrorMessage = useSelector(
    (state: FullTimeShiftRootState) => state.fullTimeShifts?.getLatestSchedulingStatus?.errorMessage
  );

  const userRolesWithPermissions = useSelector(
    (state: StoreType) => state.user?.userData?.userRolesWithPermissions
  );

  const isGenerateFullTimeShiftSchedulerModalOpen = useSelector(
    (state: FullTimeShiftRootState) => state.fullTimeShifts.isGenerateFullTimeShiftSchedulerModalOpen
  );

  const saveOverridesStatus = useSelector(
    (state: FullTimeShiftRootState) => state.fullTimeShifts?.saveOverrides?.status
  );

  const FTScheduleGenerationEnabledLocations = useSelector(
    (state: StoreType) => state.user?.userData?.FTScheduleGenerationEnabledLocations
  );
   
  return {
    currentDate,
    weekStartDay,
    getFullTimeShiftsStatus,
    getFullTimeShiftsErrorMessage,
    getFullTimeShiftsFiltersStatus,
    getFullTimeShiftsFiltersErrorMessage,
    getFullTimeShiftsMetaStatus,
    fullTimeShifts,
    filterData,
    selectedLocation,
    startingDay,
    shiftMetaList,
    jobs,
    reassignWorkersStatus,
    reassignWorkersErrorMessage,
    isUpdateDemandOpen,
    postShiftDemandStatus,
    getLatestSchedulingStatusStatus,
    getLatestSchedulingStatusErrorMessage,
    userRolesWithPermissions,
    isGenerateFullTimeShiftSchedulerModalOpen,
    saveOverridesStatus,
    FTScheduleGenerationEnabledLocations,
  };
};

export default useFullTimeShiftsData;